import { IOrganization } from '../types/interfaces';
import {
  ICreateOrganizationDto,
  IUpdateOrganizationDto,
} from '../types/organization.dtos';

export type RequiredContactFields = Pick<
  IOrganization,
  | 'esContactFirstName'
  | 'esContactLastName'
  | 'esContactAddress1'
  | 'esContactCity'
  | 'esContactState'
  | 'esContactPostalCode'
  | 'esContactEmail'
  | 'esContactJobTitle'
  | 'esContactPhone'
>;

/**
 * Note: all contact fields except for address line 2 are required.
 */
export const requiredEsContactFields: (keyof RequiredContactFields)[] = [
  'esContactFirstName',
  'esContactLastName',
  'esContactAddress1',
  'esContactCity',
  'esContactState',
  'esContactPostalCode',
  'esContactEmail',
  'esContactJobTitle',
  'esContactPhone',
];

export const requiredEsContactFieldsErrMsg =
  'All ES fields (except address line 2) are required if any ES field is provided.';

export const validateOrgEsContactInfo = (
  dto: ICreateOrganizationDto | IUpdateOrganizationDto,
) => {
  const hasEsContactInfo = requiredEsContactFields.some(
    (field) => dto[field] !== undefined && dto[field] !== null,
  );

  if (hasEsContactInfo) {
    return requiredEsContactFields.every(
      (field) => dto[field] !== undefined && dto[field] !== null,
    );
  }

  return true; // If no ES contact info is provided, it's valid
};
